import {
  Component,
  Input,
  Output,
  EventEmitter,
  TemplateRef
} from '@angular/core';
import { CalendarEvent } from './../../utils/CalendarEvent';
import { WeekDay } from '../../utils/week-day';
export class WeekViewHeaderComponent {

   days: WeekDay[];

   allDayEvents;

   locale: string;

   customTemplate: TemplateRef<any>;
/**
 * Called when the event title is clicked
 */
eventClicked: EventEmitter<{ event: CalendarEvent }> = new EventEmitter<{
    event: CalendarEvent;
  }>();

  
  dayHeaderClicked: EventEmitter<{ day: WeekDay }> = new EventEmitter<{
    day: WeekDay;
  }>();

  
  eventDropped: EventEmitter<{
      event: CalendarEvent;
      newStart: Date;
    }> = new EventEmitter<{ event: CalendarEvent; newStart: Date }>();

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'calendar-week-view-header',
  template: `
    <ng-template
    #defaultTemplate
    let-days="days"
    let-locale="locale"
    let-dayHeaderClicked="dayHeaderClicked"
    let-eventDropped="eventDropped">
    <div class="cal-week-day-headers">
    <div class="cal-day-headers">
      <div
        class="cal-header"
        *ngFor="let day of days"
        [class.cal-past]="day.isPast"
        [class.cal-today]="day.isToday"
        [class.cal-future]="day.isFuture"
        [class.cal-weekend]="day.isWeekend"
        [class.cal-drag-over]="day.dragOver"
        [ngClass]="day.cssClass"
        (click)="dayHeaderClicked.emit({day: day})"
        mwlDroppable
        (dragEnter)="day.dragOver = true"
        (dragLeave)="day.dragOver = false"
        (drop)="day.dragOver = false; eventDropped.emit({event: $event.dropData.event, newStart: day.date})">
        <b>{{ day.date | date:'E' }}</b><br>
        <span>{{ day.date | date:'d' }}</span>
      </div>
    </div>
    <div #eventRowContainer class="cal-events-row">
      <div
      *ngFor="let weekEvent of allDayEvents"
      #event
      class="cal-event-container"
      [style.width]="(((100 / days.length) * weekEvent.span)) + '%'"
      [style.marginLeft]="(((100 / days.length) * weekEvent.offset)) + '%'"
      [style.marginTop.px]="0" 
      [style.height.px]="weekEvent.height -6"
      >
      <div
      class="cal-event"
      (click)="eventClicked.emit({event : weekEvent.event})"
      [class.cal-starts-within-week]="weekEvent.startsBeforeWeek"
      [class.cal-ends-within-week]="weekEvent.endsAfterWeek"
      [style.backgroundColor]="weekEvent.event.color ? weekEvent.event.color : weekEvent.event.calendar.color">
        {{ weekEvent.event.title }}
    </div>
    </div>
    </div>
    </div>
    </ng-template>
    <ng-template
    [ngTemplateOutlet]="defaultTemplate"
    [ngTemplateOutletContext]="{days: days, locale: locale, dayHeaderClicked: dayHeaderClicked, eventDropped: eventDropped}">
    </ng-template>
  `,
  styles: [`
    .cal-week-day-headers{
        position: relative;
        margin-left: 50px;
        background-color: white;
      }
    .cal-day-headers {
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          border: 1px solid #e1e1e1;
          background-color: white;
    }
  
    .cal-day-headers .cal-header {
          -webkit-box-flex: 1;
              -ms-flex: 1;
                  flex: 1;
          text-align: center;
          padding: 5px 0;
          font-size: 12px;
          color: #555555;
    }

    .cal-events-row{
          border: 1px solid #e1e1e1;
          background-color: white;
          position: relative;
    }

    .cal-event {
          padding: 5px;
          font-size: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          height: 100%;
          -webkit-box-sizing: border-box;
                  box-sizing: border-box;
          margin: 2px !important;
          color: white;
          cursor: pointer;
        } 
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'days': [{ type: Input },],
'allDayEvents': [{ type: Input },],
'locale': [{ type: Input },],
'customTemplate': [{ type: Input },],
'eventClicked': [{ type: Output },],
'dayHeaderClicked': [{ type: Output },],
'eventDropped': [{ type: Output },],
};
}

function WeekViewHeaderComponent_tsickle_Closure_declarations() {
/** @type {?} */
WeekViewHeaderComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
WeekViewHeaderComponent.ctorParameters;
/** @type {?} */
WeekViewHeaderComponent.propDecorators;
/** @type {?} */
WeekViewHeaderComponent.prototype.days;
/** @type {?} */
WeekViewHeaderComponent.prototype.allDayEvents;
/** @type {?} */
WeekViewHeaderComponent.prototype.locale;
/** @type {?} */
WeekViewHeaderComponent.prototype.customTemplate;
/**
 * Called when the event title is clicked
 * @type {?}
 */
WeekViewHeaderComponent.prototype.eventClicked;
/** @type {?} */
WeekViewHeaderComponent.prototype.dayHeaderClicked;
/** @type {?} */
WeekViewHeaderComponent.prototype.eventDropped;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
